import React from 'react';
import { Loader2 } from 'lucide-react';
import { useEdificioOp } from '../../contexts/EdificioOpContext';
import EdificioReservas from '../edificio/EdificioReservas';

export default function OperacionesReservas() {
  const { edificioId, edificioActivo, loading } = useEdificioOp();

  if (loading) {
    return <div className="p-12 text-center"><Loader2 className="w-5 h-5 animate-spin text-slate-400 inline" /></div>;
  }

  if (!edificioId) {
    return <div className="p-8 text-center text-slate-500">Elegí un edificio en el menú lateral.</div>;
  }

  return (
    <EdificioReservas
      key={edificioId}
      edificioId={edificioId}
      titulo={`Reservas · ${edificioActivo?.nombre || ''}`}
      subtitulo="Visualización en tiempo real."
    />
  );
}
